import { BookMarkerOutlineIcon } from './BookMarkerOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 69EBC2C1-A3D3-42E6-9868-3E97DD6DD301
 * name book-marker-outline
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/book-marker-outline.svg
 * tags
 * - Navigation 
 */
export const BookLocationOutlineIcon = BookMarkerOutlineIcon;
export default BookLocationOutlineIcon